// Lanerunner Affiliate Program — public-facing terms
// Edit this file to update the terms shown on /affiliates.

export const AFFILIATE_TERMS = {
  commissionPct: 20,
  commissionDurationMonths: 12,
  cookieWindowDays: 90,
  minimumPayoutUSD: 50,
  refundClawbackDays: 60,
  payoutCadence: "Monthly",
  payoutMethods: "PayPal or ACH",
} as const;

export const REACH_BUCKETS = [
  { value: "<1k", label: "Under 1,000" },
  { value: "1k-10k", label: "1,000 – 10,000" },
  { value: "10k-50k", label: "10,000 – 50,000" },
  { value: "50k+", label: "50,000+" },
] as const;

export const CHANNEL_OPTIONS = [
  "YouTube",
  "TikTok",
  "Instagram",
  "Facebook",
  "X / Twitter",
  "LinkedIn",
  "Podcast",
  "Newsletter",
  "Blog / Website",
  "Discord / Community",
  "Trucking school / Coaching",
  "Other",
] as const;
